if(!customElements.get('wlsn-cart-drawer-button')) {
  class WLSNCartDrawerButton extends HTMLElement {
    constructor() {
      super();

      this.classes = {
        cartDrawer: 'wlsn-cart-drawer',
      }

      this.bindMethods = {
        handleToggleCartDrawer: this._handleToggleCartDrawer.bind(this)
      }
    }

    get elements() {
      return {
        cartDrawer: document.querySelector(`${this.classes.cartDrawer}`),
      }
    }

    connectedCallback() {
      this.addEventListener('click', this.bindMethods.handleToggleCartDrawer);
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.bindMethods.handleToggleCartDrawer);
    }

    /**
     * Call the toggleCartDrawer method on the cart drawer.
     * @returns {void}
     */
    _handleToggleCartDrawer() {
      const { cartDrawer } = this.elements;
      if (!cartDrawer) return;
      cartDrawer.toggleCartDrawer();
    }

  }
  customElements.define('wlsn-cart-drawer-button', WLSNCartDrawerButton);
}